import { Attribute, BuyXGetYDetailsSchedule } from '@cinemark/content-api-client';

export type ShowtimeCastMember = {
  characterName?: string;
  name: string;
};

export type BasicShowtime = {
  id: number;
  isPrivateWatchParty: boolean;
  linkedShowtimeId: number;
  midnightShowtime?: boolean;
  nextShowtime?: BasicShowtime;
  passRestricted?: boolean;
  previousShowtime?: BasicShowtime;
  seatingConfigId: number;
  seatsAvailable: number;
  startTime: Date;
  status: ShowtimeStatusType;
  totalSeats: number;
};

export enum ShowtimeStatusType {
  Saleable,
  Expired,
  SoldOut,
  PreSaleOnly,
  VipBoxOfficeOnly,
  MetOperaPatronsOnly,
}

export type TheaterShowtimeGroup = {
  auditoriumAttributes: Attribute[];
  passRestricted?: boolean;
  printTypeName: string;
  printTypeText?: string;
  showtimeAttributes: Attribute[];
  showtimes: BasicShowtime[];
};

export type TheaterShowtimeItem = {
  advanceTicketsEndDate?: Date;
  advanceTicketsStartDate?: Date;
  buyXGetYDetailsSchedules?: BuyXGetYDetailsSchedule[];
  cinemarkMovieId: number;
  hasPresaleShowtimes?: boolean;
  movieCast?: ShowtimeCastMember[];
  movieDirector?: string;
  movieGenre?: string;
  movieId: number;
  movieLanguage?: string;
  movieOfficialSite?: string;
  moviePosterAlt?: string;
  moviePosterUrl?: string;
  movieProducer?: string;
  movieRating?: string;
  movieReleaseDate?: Date;
  movieRuntime?: string;
  movieRuntimeMinutes?: number;
  movieSlug: string;
  movieSynopsis?: string;
  movieTitle?: string;
  movieTitleAttributeList: Attribute[];
  movieTrailerUrl?: string;
  movieUrl: string;
  movieWriter?: string;
  presaleDateTimeAppender?: string;
  presaleLinkText?: string;
  presaleLinkUrl?: string;
  publicOnSaleDate?: Date;
  showtimesByPrintType: TheaterShowtimeGroup[];
  theaterId: number;
};

export type MovieShowtimeItem = {
  address?: string;
  address2?: string;
  buyXGetYDetailsSchedules?: BuyXGetYDetailsSchedule[];
  city?: string;
  distanceMiles?: number;
  mapUrl?: string;
  showtimesByPrintType: TheaterShowtimeGroup[];
  state?: string;
  theaterId: number;
  theaterName: string;
  theaterSlug: string;
  theaterUrl?: string;
  timeZone?: string;
  zipCode?: string;
};

export type MovieShowtimesResponse = {
  hasMoreTheaters?: boolean;
  hasPresaleShowtimes?: boolean;
  movieTitle?: string;
  presaleDateTimeAppender?: string;
  presaleLinkText?: string;
  presaleLinkUrl?: string;
  publicOnSaleDate?: Date;
  theaters: MovieShowtimeItem[];
};
